import { Lock as LockIcon } from '@mui/icons-material';
import { Box, styled } from '@mui/material';

const StyledCircleContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.error.light,
  marginBottom: theme.spacing(3),
  borderRadius: '50%',
  width: '80px',
  height: '80px',
}));

const StyledDeleteIcon = styled(LockIcon)(() => ({
  color: '#fff',
}));

const StyledTextContainer = styled(Box)(() => ({
  textAlign: 'center',
  lineHeight: 2,
}));

export { StyledCircleContainer, StyledDeleteIcon, StyledTextContainer };
